export default __webpack_public_path__ + "static/media/chart-loader-white.bd66d118.svg";